// Import both Container and ConsoleComponent at the top of your file
import Container from "./Container";
import ConsoleComponent from "./ConsoleComponent"; // Adjust the import path as necessary

const Hero = () => {
  return (
    <div className="h-[55vh] flex items-center bg-1 pt-20 z-10s bg-3">
      <Container>
        <div>
          <div className="flex">
            <div className="mt-10 text-left">
              <h2 className="text-2xl sm:text-3xl  md:text-5xl  h-color-2 font-extrabold tracking-wider mb-3">
                Hi, I'm Mizuki!
              </h2>
              <h2 className="text-2xl sm:text-3xl md:text-5xl  h-color-2 font-extrabold tracking-wider mb-3">
                I'm a frontend developer
              </h2>
              <h2 className="text-2xl sm:text-3xl  md:text-5xl  h-color-2 font-extrabold tracking-wider mb-3">
                and a{" "}
                <ConsoleComponent
                  words={["sydney sider", "birds lover", "volleyball player"]}
                  colors={["#ff5470", "#fde24f", "#00ebc7"]}
                  isNavOpen={false}
                  setIsNavOpen={function (isOpen: boolean): void {
                    throw new Error("Function not implemented.");
                  }}
                />
              </h2>
            </div>
          </div>
        </div>
        <div className="flex justify-center">
          <a
            className=" block bg-highlight font-bold p-4 rounded-sm mt-10"
            href="/Mizuki-Kawabe_Resume.pdf"
            download
          >
            Here is my resume!
          </a>
        </div>
      </Container>
    </div>
  );
};

export default Hero;
